import { Pipe, PipeTransform } from '@angular/core';
import { formatDistance } from 'date-fns';

@Pipe({
    name: 'fromNow', pure: true,
    standalone: false
})
export class FromNowPipe implements PipeTransform {
  transform(date: string | Date, baseDate: Date = new Date()): string {
    if (!!date) {
      if (typeof date === 'string') {
        var parsedDate;
        try {
          parsedDate = Date.parse(date);
        } catch {}
        if (!!parsedDate && !Number.isNaN(parsedDate)) {
          return formatDistance(Date.parse(date), baseDate, { addSuffix: true });
        }
      } else if (date instanceof Date) {
        return formatDistance(date, baseDate, { addSuffix: true });
      }
    }
    return '';
  }
}
